import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getGlobalLists = async () => {
  const response = await axios.get(`${API_URL}/api/global-lists`, { headers: getAuthHeader() });
  return response.data;
};

export const getGlobalList = async (key) => {
  const response = await axios.get(`${API_URL}/api/global-lists/${key}`, { headers: getAuthHeader() });
  return response.data;
};

export const createGlobalList = async (data) => {
  const response = await axios.post(`${API_URL}/api/global-lists`, data, { headers: getAuthHeader() });
  return response.data;
};

export const updateGlobalList = async (key, data) => {
  const response = await axios.put(`${API_URL}/api/global-lists/${key}`, data, { headers: getAuthHeader() });
  return response.data;
};

export const deleteGlobalList = async (key) => {
  const response = await axios.delete(`${API_URL}/api/global-lists/${key}`, { headers: getAuthHeader() });
  return response.data;
};

export const addGlobalListItem = async (key, item) => {
  const response = await axios.post(`${API_URL}/api/global-lists/${key}/items`, item, { headers: getAuthHeader() });
  return response.data;
};

export const updateGlobalListItem = async (key, value, item) => {
  const response = await axios.put(`${API_URL}/api/global-lists/${key}/items/${encodeURIComponent(value)}`, item, { headers: getAuthHeader() });
  return response.data;
};

export const deleteGlobalListItem = async (key, value) => {
  const response = await axios.delete(`${API_URL}/api/global-lists/${key}/items/${encodeURIComponent(value)}`, { headers: getAuthHeader() });
  return response.data;
};
